import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomInput from '../../../../components/custom-input/CustomInput';

const Participant = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation();
  return (
    <Stack sx={{ pl: '24px' }}>
      <Typography variant="heading5" color="primaryDark.500">
        {t('projects.projectRequest.projectPartnerInformation')}
      </Typography>
      <Divider sx={{ mt: '0.75rem', mb: '1rem' }} />

      <Stack
        direction="row"
        justifyContent="space-between"
        gap={2}
        sx={{ pr: '20px' }}
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Stack sx={{ width: '50%' }}>
          <CustomInput
            input={<CustomInput.Text />}
            name="participantCompanyName"
            type="text"
            placeholder={t('common.companyName')}
            label={t('common.companyName')}
            required
            sx={{ paddingBottom: '1.25rem' }}
            disabled={isLoading}
          />

          <CustomInput
            input={<CustomInput.Text />}
            name="participantCompanyUrl"
            type="text"
            placeholder={t('common.companyWebsite')}
            label={t('common.companyWebsite')}
            sx={{ paddingBottom: '1.25rem' }}
            disabled={isLoading}
          />
        </Stack>

        <Stack direction="column" sx={{ width: '50%' }}>
          <CustomInput
            input={<CustomInput.Text />}
            name="contactName"
            type="text"
            placeholder={t('projects.projectRequest.contactName')}
            label={t('projects.projectRequest.contactName')}
            sx={{ paddingBottom: '1.25rem' }}
            disabled={isLoading}
          />

          <CustomInput
            input={<CustomInput.Text />}
            name="contactEmail"
            type="text"
            placeholder={t('projects.projectRequest.personalBusinessEmail')}
            label={t('projects.projectRequest.personalBusinessEmail')}
            sx={{ paddingBottom: '1.25rem' }}
            disabled={isLoading}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Participant;
